import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, switchMap, tap, throttleTime } from 'rxjs/operators';
import { CurrentExamService } from './current-exam.service';
import { ReportExamService } from './report-exam.service';
import { ReportLogLevel } from './enums/report-level.enum';

export enum HotkeyEventSource {
  App = 'Application',
  PdfDoc = 'Pdf document',
  TextNote = 'Text note',
  FroalaEditor = 'Text editor',
}

export type HotkeyEvent = {
  hotkey: string;
  source: HotkeyEventSource;
};

@Injectable({
  providedIn: 'root',
})
export class HotkeysService {
  public hotkeyDetected: Subject<HotkeyEvent> = new Subject();
  private hotkeyStorage: HotkeyEvent[] = [];

  constructor(
    private readonly examService: CurrentExamService,
    private readonly reportService: ReportExamService,
  ) {
    const hotkeyObs = this.hotkeyDetected.pipe(
      tap((e) => this.hotkeyStorage.push(e)),
      throttleTime(1000)
    );

    const _examInProgressObs = this.examService.inProgressObservable.pipe(
      filter((v) => !!v),
      switchMap(() => hotkeyObs)
    );

    _examInProgressObs.subscribe(() => {
      const filtered = this.removeDuplicates();
      this.reportService.sendCustomMessageReport(
        ReportLogLevel.Hotkeys,
        JSON.stringify(filtered)
      );
      this.hotkeyStorage = [];
    });
  }

  private removeDuplicates() {
    const uniqueArr = this.hotkeyStorage.filter((value, index, self) => {
      return (
        self.findIndex((t) => JSON.stringify(t) === JSON.stringify(value)) === index
      );
    });

    return uniqueArr;
  }
}
